// تعیین محل اعتبار اقلام حقوق
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa  = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

// برچسب نحوه‌ی اجرا؛ سه گزینه بسته به نوع منبع اعتبار
const RUN_KIND = ['—', 'نحوه اجرا ۱', 'نحوه اجرا ۲', 'نحوه اجرا ۳'];

const EMPTY = {
  credit_id: 0, credit: '', accounting_kind: 0, project_id: 0, project: '', is_personel: 0,
  hazineh_id: 0, hz0: '', hazineh_id1: 0, hz1: '', hazineh_id2: 0, hz2: '',
  hazineh_id3: 0, hz3: '', hazineh_id4: 0, hz4: '', hazineh_id5: 0, hz5: '',
};

const API = (path, opts = {}) => fetch(`/api/budget${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

function Lookup({ label, value, endpoint, extra = '', onPick, flex = 1, disabled }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => {
    setQ(text);
    const j = await API(`${endpoint}?q=${encodeURIComponent(text)}${extra}`);
    if (j.ok) { setRows(j.rows); setOpen(true); }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => !disabled && search(q)} onChange={e => !disabled && search(e.target.value)}
        placeholder="جستجو..." disabled={disabled}
        style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
      {value && !disabled && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 700, maxHeight: '240px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
              {r.display}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function BudgetPayrolCreditPlace({ user, onBack }) {
  // دکمه‌های فرم FRMPAYROLCREDITPLACE؛ دیدن = دسترسی
  const vbf = useFormButtons('FRMPAYROLCREDITPLACE', ["BTNEDIT","BTNOK"]);
  const [search, setSearch] = useState('');
  const [data,     setData]     = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [modal,    setModal]    = useState(null);
  const [form,     setForm]     = useState(EMPTY);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');
  const [toast,    setToast]    = useState('');

  const [total,    setTotal]    = useState(0);
  const [page,     setPage]     = useState(1);
  const [hasMore,  setHasMore]  = useState(false);
  const [loadMore, setLoadMore] = useState(false);

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };

  const cols = ['نوع استخدام', 'عنوان پرداختی', 'عنوان مطالبات', 'منبع اعتبار', 'فعالیت / پروژه',
    'کد هزینه ۱', 'کد هزینه ۲', 'کد هزینه ۳', 'کد هزینه ۴', 'کد هزینه ۵', 'کد هزینه ۶', 'نحوه اجرا'];
  const initW = [130, 170, 130, 200, 200, 140, 140, 140, 140, 140, 140, 100];
  const [colW, setColW] = useState(initW);
  const colWRef = useRef(initW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const buildUrl = (pg) => `/payrol-credit-place/?search=${encodeURIComponent(search)}&page=${pg}`;

  const load = useCallback(async () => {
    setLoading(true); setError(''); setPage(1); setSelected(null);
    const j = await API(buildUrl(1));
    setLoading(false);
    if (j.ok) { setData(j.data); setTotal(j.total || j.data.length); setHasMore(j.has_more || false); }
    else setError(j.msg);
  }, [search]);

  const loadNextPage = async () => {
    const next = page + 1; setLoadMore(true);
    const j = await API(buildUrl(next));
    setLoadMore(false);
    if (j.ok) { setData(d => [...d, ...j.data]); setHasMore(j.has_more || false); setPage(next); }
  };

  useEffect(() => { load(); }, []);

  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({
      credit_id: selected.credit_id, credit: selected.credit, accounting_kind: selected.accounting_kind,
      project_id: selected.project_id, project: selected.project, is_personel: selected.is_personel,
      hazineh_id: selected.hazineh_id, hz0: selected.hz0,
      hazineh_id1: selected.hazineh_id1, hz1: selected.hz1,
      hazineh_id2: selected.hazineh_id2, hz2: selected.hz2,
      hazineh_id3: selected.hazineh_id3, hz3: selected.hz3,
      hazineh_id4: selected.hazineh_id4, hz4: selected.hz4,
      hazineh_id5: selected.hazineh_id5, hz5: selected.hz5,
    });
    setError(''); setModal('edit');
  };

  const save = async () => {
    setSaving(true); setError('');
    const body = JSON.stringify({
      credit_id: form.credit_id, project_id: form.project_id, is_personel: form.is_personel,
      hazineh_id: form.hazineh_id, hazineh_id1: form.hazineh_id1, hazineh_id2: form.hazineh_id2,
      hazineh_id3: form.hazineh_id3, hazineh_id4: form.hazineh_id4, hazineh_id5: form.hazineh_id5,
    });
    const j = await API(`/payrol-credit-place/${selected.id}/update/`, { method: 'PUT', body });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  const hzPicker = (level, idKey, txtKey) => (
    <Lookup label={`کد هزینه ${toFa(level)}`} value={form[txtKey]} endpoint="/payrol-credit-place/lookup/hazineh/"
      extra={`&level=${level}`}
      onPick={r => setForm(f => ({ ...f, [idKey]: r.id, [txtKey]: r.display }))} />
  );

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ تعیین محل اعتبار</button>}
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && load()}
        style={{ ...ui.searchInput, flex: 1, minWidth: '150px' }} placeholder="جستجو (نوع استخدام یا عنوان پرداختی)..." />
      {loading && <span>⏳</span>}
      {!loading && data.length > 0 && <div style={ui.countBadge}>{toFa(data.length)} از {toFa(total)} قلم</div>}
    </>
  );

  const footer = (hasMore && !search) ? (
    <button onClick={loadNextPage} disabled={loadMore} style={{
      padding: '9px 36px', background: loadMore ? '#ccc' : 'linear-gradient(135deg,#1a2f50,#1a237e)',
      color: '#fff', border: 'none', borderRadius: '8px', cursor: loadMore ? 'default' : 'pointer',
      fontFamily: 'inherit', fontSize: '13px', fontWeight: '700' }}>
      {loadMore ? '⏳ در حال بارگذاری...' : `▼ ۲۰۰ مورد بعدی (${toFa(String(total - data.length))} باقی‌مانده)`}
    </button>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title="تعیین محل اعتبار اقلام حقوق" subtitle="بخش بودجه — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''} footer={footer}>
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((h, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
              const tc  = sel ? '#fff' : '#111';
              const cell = (v, extra = {}) => <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis', ...extra }} title={v}>{v || '•'}</td>;
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                  onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  {cell(r.serv_type)}
                  {cell(r.pay_title, { fontWeight: '600' })}
                  {cell(r.taking)}
                  {cell(r.credit)}
                  {cell(r.project)}
                  {cell(r.hz0)}
                  {cell(r.hz1)}
                  {cell(r.hz2)}
                  {cell(r.hz3)}
                  {cell(r.hz4)}
                  {cell(r.hz5)}
                  <td style={{ ...ui.td, fontSize: '11px', color: tc }}>{RUN_KIND[r.is_personel] || '•'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 قلمی یافت نشد</div>}
      </ListPage>

      {modal === 'edit' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '860px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>✎ محل اعتبار: {selected?.pay_title}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={{ background: '#f4f6fb', borderRadius: '8px', padding: '8px 12px', marginBottom: '12px', fontSize: '12px', color: '#1a2f50' }}>
                نوع استخدام: <b>{selected?.serv_type || '—'}</b>{selected?.taking ? <> | عنوان مطالبات: <b>{selected.taking}</b></> : null}
              </div>

              <div style={ui.row}>
                <Lookup label="منبع اعتبار" value={form.credit} endpoint="/payrol-credit-place/lookup/credit/"
                  onPick={r => setForm(f => ({ ...f, credit_id: r.id, credit: r.display,
                    accounting_kind: r.accounting_kind ?? f.accounting_kind, project_id: 0, project: '' }))} flex={2} />
              </div>
              <div style={ui.row}>
                <Lookup label={form.accounting_kind ? 'پروژه' : 'فعالیت'} value={form.project}
                  endpoint="/payrol-credit-place/lookup/project/" extra={`&kind=${form.accounting_kind}`}
                  onPick={r => setForm(f => ({ ...f, project_id: r.id, project: r.display }))} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>نحوه اجرا</label>
                  <select value={form.is_personel} onChange={e => setForm(f => ({ ...f, is_personel: Number(e.target.value) }))} style={ui.input}>
                    {RUN_KIND.map((o, i) => <option key={i} value={i}>{o}</option>)}
                  </select>
                </div>
              </div>

              <div style={ui.divider} />
              <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a2f50', marginBottom: '8px' }}>کدهای هزینه (سطح ۱ تا ۶)</div>
              <div style={ui.row}>
                {hzPicker(1, 'hazineh_id', 'hz0')}
                {hzPicker(2, 'hazineh_id1', 'hz1')}
                {hzPicker(3, 'hazineh_id2', 'hz2')}
              </div>
              <div style={ui.row}>
                {hzPicker(4, 'hazineh_id3', 'hz3')}
                {hzPicker(5, 'hazineh_id4', 'hz4')}
                {hzPicker(6, 'hazineh_id5', 'hz5')}
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
